// extracted by mini-css-extract-plugin
export default {"orderRight":"orderRight_orderRight__M4VFF"};